import { EllipsisMenuItemStatus } from '@platform/ui-library';
import { FC, useEffect } from 'react';
import { channelTypeOptions } from '@app/const';
import { ToolbarDropdown } from '@app/form_components';
import { useDesign } from '@app/hooks';
import { useGlobalSettings } from '@app/stores';
import { DesignChannelType } from '@app/types';

type ChannelSettingSelectorProps = {
  onChange?: () => void;
};

export const ChannelSettingSelector: FC<ChannelSettingSelectorProps> = ({ onChange }) => {
  const { channels, defaultChannel } = useDesign().rootSettings;
  const { channel, setSettings } = useGlobalSettings();

  const handleChange = (newChannel: string) => {
    setSettings({ channel: newChannel as DesignChannelType });
    window.apm.setSerializedChanged();
    window.apm.postEventToCurrentView({ target: 'request-refresh' });
    onChange?.();
  };

  useEffect(() => {
    if (!channel || !(channel in channels)) {
      handleChange(defaultChannel);
    }
  }, [channel, channels, setSettings]);

  const availableChannels = channelTypeOptions.filter((option) => {
    return option.value in channels;
  });

  const currentChannel = channel ?? defaultChannel;
  const items = availableChannels.map(({ name, value }) => {
    const label = (value !== defaultChannel) ? name : `${name} (default)`;
    return {
      action: () => handleChange(value),
      label,
      status: (value === currentChannel) ? EllipsisMenuItemStatus.Selected : undefined
    };
  });

  const triggerLabel = (
    availableChannels.find(({ value }) => value === currentChannel)?.name
    ?? String(currentChannel)
  );
  const displayLabel = (currentChannel === defaultChannel) ? (
    `${triggerLabel} (default)`
  ) : triggerLabel;

  return (
    <ToolbarDropdown className="selector" items={items}>
      {displayLabel}
    </ToolbarDropdown>
  );
};
